let initialState = {
  user: {},
  isLoggedIn: localStorage.getItem('isLoggedIn') ? true : false,
  token: localStorage.getItem('token') ? localStorage.getItem('token') : null
}

export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setAuth":
      localStorage.setItem('isLoggedIn', true)
      localStorage.setItem('token', action.payload.token)
      return { ...state, isLoggedIn: true, token: action.payload.token, user: action.payload.user };
    case "removeAuth":
      localStorage.removeItem('isLoggedIn')
      localStorage.removeItem('token')
      return { ...state, user: null, isLoggedIn: false, token: null };
    case "setUserDetail":
      return { 
        ...state, 
        user: {
          email: action.payload.email,
          name: action.payload.name,
          roles: action.payload.roles || [],
          notificationsList: action.payload.notificationsList || [],
          unreadNotifications: action.payload.unreadNotifications || 0,
        },
      };    
    default:
      return state;
  }
};

export const setAuth = (payload) => ({
  type: "setAuth",
  payload,
});
export const removeAuth = (payload) => ({
  type: "removeAuth",
  payload,
});
export const setUserDetail = (payload) => ({
  type: "setUserDetail",
  payload,
});
